import React from "react";
import { Container, Row, Col } from "reactstrap";

const team = [
  {
    name: "Dra. Paula González",
    role: "Ortodoncia, Ortopedia Maxilar, Odontología Integral",
    img: require("assets/img/dentist-profiles/paula_gonzalez_2.png")
  },
  {
    name: "Dra. Vanesa Vélez",
    role: "Odontología Integral, Implantología, Ortodoncia",
    img: require("assets/img/dentist-profiles/vanesa_velez.png")
  },
  {
    name: "Dra. María Rodríguez",
    role: "Odontología Integral, Implantología, Ortodoncia",
    img: require("assets/img/dentist-profiles/maria_rodriguez_2.png")
  },
  {
    name: "Dra. Karen Ocampo",
    role: "Odontología General, Odontopediatría, Blanqueamiento",
    img: require("assets/img/dentist-profiles/karen_ocampo.png")
  },
  {
    name: "Dra. Agustina Toriani",
    role: "Endodoncia, Odontología General, Ortodoncia",
    img: require("assets/img/dentist-profiles/agustina_toriani.png")
  },
  {
    name: "Dr. Nicolás Martini",
    role: "Odontología Estética, Rehabilitación, Odontología Integral",
    img: require("assets/img/dentist-profiles/nicolas_martini_2.png")
  }
];

export default function Team() {
  return (
    <div className="section section-alt" id="team">
      <Container>
        <Row className="justify-content-center">
          <Col md="8" className="text-center">
            <h2 className="section-title reveal">Nuestro equipo</h2>
            <p className="section-lead reveal">
              Profesionales altamente calificados comprometidos con tu salud bucal
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center">
          {team.map(m => (
            <Col md="4" lg="3" sm="6" key={m.name} className="mb-4 d-flex reveal">
              <div className="staff-card">
                <div className="staff-photo-frame">
                  <img src={m.img} alt={m.name} className="staff-photo" />
                </div>
                <h3 className="staff-name">{m.name}</h3>
                <div className="staff-tags">
                  {m.role.split(",").map(rol => (
                    <span key={rol} className="staff-tag">
                      {rol.trim()}
                    </span>
                  ))}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
